export enum MileageDownloadRequestTimezone {
  EUROPE_WARSAW = "Europe/Warsaw",
  UTC = "UTC",
}

export type MileageDownloadRequestSeparatorTypes = ";" | ",";

export enum MileageDownloadRequestOrder {
  DATE_ASC = "DATE_ASC",
  DATE_DESC = "DATE_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  WORKER_NAME_ASC = "WORKER_NAME_ASC",
  WORKER_NAME_DESC = "WORKER_NAME_DESC",
  WORKER_LAST_NAME_ASC = "WORKER_LAST_NAME_ASC",
  WORKER_LAST_NAME_DESC = "WORKER_LAST_NAME_DESC",
  CARD_NO_ASC = "CARD_NO_ASC",
  CARD_NO_DESC = "CARD_NO_DESC",
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  CARGO_COMPANY_NAME_ASC = "CARGO_COMPANY_NAME_ASC",
  CARGO_COMPANY_NAME_DESC = "CARGO_COMPANY_NAME_DESC",
}

export type MileageDownloadRequestQueryParams = {
  separator?: MileageDownloadRequestSeparatorTypes;
  timezone?: MileageDownloadRequestTimezone;
  mileages: string;
  order?: MileageDownloadRequestOrder;
};

type MileageDownloadRequest = {
  mileageUuids: string[];
  separator?: MileageDownloadRequestSeparatorTypes;
  timezone?: MileageDownloadRequestTimezone;
  order?: MileageDownloadRequestOrder;
};

export default MileageDownloadRequest;
